/**
 * WinterHat.jsx
 * Decorative Santa/Christmas hat overlay for logos
 */
import React from 'react';

const WinterHat = ({ size = 'medium', enabled = true }) => {
  if (!enabled) return null;

  // Size configurations
  const sizeConfig = {
    small: { width: 30, height: 25, top: -18, right: -5 },
    medium: { width: 45, height: 38, top: -28, right: -8 },
    large: { width: 60, height: 50, top: -38, right: -12 }
  };

  const config = sizeConfig[size] || sizeConfig.medium;

  return (
    <svg
      viewBox="0 0 100 85"
      style={{
        position: 'absolute',
        top: config.top,
        right: config.right,
        width: config.width,
        height: config.height,
        transform: 'rotate(15deg)',
        zIndex: 10,
        filter: 'drop-shadow(2px 2px 3px rgba(0,0,0,0.3))'
      }}
    >
      {/* Hat base (red) */}
      <path
        d="M10 70 Q15 55, 30 45 Q50 20, 75 35 Q90 45, 95 70 Z"
        fill="#DC2626"
        stroke="#B91C1C"
        strokeWidth="1"
      />
      
      {/* White fur trim at bottom */}
      <ellipse
        cx="52"
        cy="72"
        rx="48"
        ry="12"
        fill="white"
        stroke="#E5E5E5"
        strokeWidth="0.5"
      />
      
      {/* Fur texture dots */}
      <circle cx="20" cy="72" r="2" fill="#F5F5F5" />
      <circle cx="35" cy="70" r="1.5" fill="#F5F5F5" />
      <circle cx="50" cy="73" r="2" fill="#F5F5F5" />
      <circle cx="65" cy="71" r="1.5" fill="#F5F5F5" />
      <circle cx="80" cy="72" r="2" fill="#F5F5F5" />
      
      {/* Hat tip curl */}
      <path
        d="M75 35 Q85 25, 92 30 Q98 38, 90 45"
        fill="#DC2626"
        stroke="#B91C1C"
        strokeWidth="1"
      />
      
      {/* Pompom at tip */}
      <circle
        cx="92"
        cy="32"
        r="10"
        fill="white"
        stroke="#E5E5E5"
        strokeWidth="0.5"
      />
      
      {/* Pompom texture */}
      <circle cx="88" cy="30" r="2" fill="#F5F5F5" />
      <circle cx="94" cy="28" r="1.5" fill="#F5F5F5" />
      <circle cx="96" cy="34" r="2" fill="#F5F5F5" />
      <circle cx="90" cy="36" r="1.5" fill="#F5F5F5" />
      
      {/* Subtle highlight on hat */}
      <path
        d="M25 60 Q35 50, 50 42"
        fill="none"
        stroke="#EF4444"
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.5"
      />
    </svg>
  );
};

export default WinterHat;
